// extracted by mini-css-extract-plugin
export var simpleBanner = "index-module--simpleBanner--d88c4";
export var simpleBannerImg = "index-module--simpleBannerImg--48683";
export var simpleBannerTitle = "index-module--simpleBannerTitle--5be28";
export var simpleBannerWrapper = "index-module--simpleBannerWrapper--89a60";
export var slimBanner = "index-module--slimBanner--fdcee";